export default __webpack_public_path__ + "static/media/Icons-35.5f8ed47c.png";